import { Link } from 'react-router-dom';
import { Database, Key, RefreshCw, Settings, Shield, Users } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const SECOES = [
  {
    to: '/configuracoes/varreduras',
    icon: RefreshCw,
    label: 'Varreduras',
    descricao: 'Histórico de descobertas automáticas e disparo manual',
    active: true,
  },
  {
    to: '/configuracoes/tokens',
    icon: Key,
    label: 'Tokens de API',
    descricao: 'Tokens pra hook Claude Code e integrações externas',
    active: true,
  },
  {
    to: '#',
    icon: Users,
    label: 'Usuários',
    descricao: 'Gerenciar time (admin, editor, viewer)',
    active: false,
  },
  {
    to: '#',
    icon: Database,
    label: 'Backups',
    descricao: 'Snapshots do banco SQLite',
    active: false,
  },
  {
    to: '#',
    icon: Shield,
    label: 'Segurança',
    descricao: 'Rotação de master key, auditoria',
    active: false,
  },
  {
    to: '#',
    icon: Settings,
    label: 'Preferências',
    descricao: 'Tema, notificações, atalhos',
    active: false,
  },
];

export function ConfiguracoesPage(): JSX.Element {
  return (
    <div className="space-y-4 max-w-4xl">
      <div>
        <h1 className="text-2xl font-semibold">Configurações</h1>
        <p className="text-sm text-muted-foreground">Administração da Central</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {SECOES.map((s) => {
          const content = (
            <Card className={!s.active ? 'opacity-50' : 'hover:border-primary/40 transition-colors'}>
              <CardHeader className="pb-2">
                <CardTitle className="flex items-center gap-2 text-base">
                  <s.icon className="h-4 w-4 text-muted-foreground" />
                  {s.label}
                  {!s.active && (
                    <span className="text-[10px] text-muted-foreground ml-auto">Em breve</span>
                  )}
                </CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">{s.descricao}</CardContent>
            </Card>
          );
          return s.active ? (
            <Link key={s.label} to={s.to}>
              {content}
            </Link>
          ) : (
            <div key={s.label}>{content}</div>
          );
        })}
      </div>
    </div>
  );
}
